import React, { useContext, useState } from "react"
import { StateMachineProvider, StateMachineStepView } from "../../context/stateMachine/StateMachineV2"
import { partnerRegistrationSection } from "./workflow"
import { useBodyClass } from "../../../utils/Hooks"

export const PartnerRegistrationFlowContext = React.createContext<PartnerRegistrationFlowContextProps>(null)

export const usePartnerRegistrationFlow = () => useContext(PartnerRegistrationFlowContext)

export default function PartnerRegistrationFlow(props): JSX.Element {
  useBodyClass("bg-warm-gray")

  const guid = props.match.params.guid
  const [password, setPassword] = useState(null)
  const [readPolicy, setReadPolicy] = useState(false)
  const [readTerms, setReadTerms] = useState(false)
  const [dataConsent, setDataConsent] = useState(false)
  const [emailOptIn, setEmailOptIn] = useState(false)

  const context = {
    guid,
    password,
    setPassword,
    readPolicy,
    setReadPolicy,
    readTerms,
    setReadTerms,
    dataConsent,
    setDataConsent,
    emailOptIn,
    setEmailOptIn
  }

  return (
    <PartnerRegistrationFlowContext.Provider value={context}>
      <StateMachineProvider
        initialSection={partnerRegistrationSection.name}
        stateMachineDescription={[partnerRegistrationSection]}
        onComplete={null}
      >
        <StateMachineStepView />
      </StateMachineProvider>
    </PartnerRegistrationFlowContext.Provider>
  )
}

export type PartnerRegistrationFlowContextProps = {
  guid: string
  password: string
  setPassword: (password: string) => void
  readPolicy: boolean
  setReadPolicy: (boolean) => void
  readTerms: boolean
  setReadTerms: (boolean) => void
  dataConsent: boolean
  setDataConsent: (boolean) => void
  emailOptIn: boolean
  setEmailOptIn: (boolean) => void
}
